import { BaseElement, defineElement } from '@webtides/element-js';

/**
 * @property {boolean} showImages
 */
export default class RecipeCookingMode extends BaseElement {
    properties() {
        return {
            showImages: false,
        };
    }

    connected() {
        this.classList.toggle('show-images', this.showImages);
    }

    afterUpdate() {
        this.classList.toggle('show-images', this.showImages);
    }

    events() {
        return {
            '[toggle-show-images]': {
                click: () => {
                    this.showImages = !this.showImages;
                },
            },
        };
    }
}

defineElement('recipe-cooking-mode', RecipeCookingMode);
